import { render, staticRenderFns } from "./ChimpHistory.vue?vue&type=template&id=0404459c&scoped=true&"
import script from "./ChimpHistory.vue?vue&type=script&lang=ts&"
export * from "./ChimpHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0404459c",
  null
  
)

export default component.exports